<template>
	<div id="operation" class="page">
		<dv-full-screen-container class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body">
				<Navbar @logout="logout" :buildingSelect='buildingSelect' :navbarType='navbarType' :building='building'
					:buildingName='buildingName' @second="recordProgress" />
				<div class="body-box" style="margin-left: 0.3rem;width: 22.9625rem;">
					<div style="height: 5.8rem;">
						<dv-border-box-6>
							<div class="d-flex pt-2 pl-2">
								<div class="d-flex">
									<span class="mt-3 ml-3 title_t">运行数据</span>
								</div>
							</div>
							<div class="d-flex jc-center table-box body-box">
								<el-table :data="operList1" highlight-current-row style="width: 98%;margin: 0 auto;"
									ref="table" height="0">
									<el-table-column prop="location" label="安装位置" align="center"></el-table-column>
									<el-table-column prop="SJSJ" label="时间" align="center" width='160'>
									</el-table-column>
									<el-table-column prop="SNWD" label="室内温度" align="center"></el-table-column>
									<el-table-column prop="SNSD" label="室内湿度" align="center"></el-table-column>
									<el-table-column prop="HSWD" label="进水温度" align="center"></el-table-column>
									<el-table-column prop="CSWD" label="出水温度" align="center"></el-table-column>
									<el-table-column prop="KGJZT" label="开关机" align="center"></el-table-column>
									<el-table-column prop="YJ1ZT" label="压机1状态" align="center"></el-table-column>
									<el-table-column prop="YJ2ZT" label="压机2状态" align="center"></el-table-column>
									<el-table-column prop="SBZT" label="水泵状态" align="center"></el-table-column>
									<el-table-column prop="DJRZT" label="电加热状态" align="center"></el-table-column>
									<el-table-column prop="YJDL" label="运行电流1" align="center"></el-table-column>
									<el-table-column prop="DRDL" label="运行电流2" align="center"></el-table-column>
									<el-table-column prop="BJXH" label="告警状态" align="center"></el-table-column>
									<el-table-column prop="STFZT" label="四通阀状态" align="center"></el-table-column>
								</el-table>
								<!-- <dv-scroll-board :config="config" style="width: 96%; height: 4.6875rem;margin: 0 auto;" /> -->
							</div>
						</dv-border-box-6>
					</div>
					<div class="mt-3" style="height: 5.8rem;">
						<dv-border-box-6>
							<div class="d-flex pt-2 pl-2">
								<div class="d-flex">
									<span class="mt-3 ml-3 title_t">温湿度数据</span>
								</div>
							</div>
							<div class="d-flex jc-around">
								<div class="left mt-3" style="width: 48%;">
									<div class="select-veido d-flex" style="height: 0.75rem;width: 96%;margin: 0 auto;">
										<div>
											<span>安装位置</span>
											<el-select style="width: 1.25rem;" v-model="value" placeholder="请选择">
												<el-option v-for="item in options" :key="item.value" :label="item.label"
													:value="item.value">
												</el-option>
											</el-select>
										</div>
										<div class="ml-5">
											<span>时间</span>
											<el-date-picker v-model="value2" type="datetimerange" align="right"
												unlink-panels range-separator="至" value-format="yyyy-MM-dd HH:mm:ss"
												:default-time="['00:00:00', '23:59:59']" start-placeholder="开始日期"
												end-placeholder="结束日期" :picker-options="pickerOptions">
											</el-date-picker>
										</div>
										<div>
											<el-button type="primary" size="medium" @click="timeChange">查询</el-button>
										</div>
									</div>
									<div class="table-box2 body-box">
										<el-table :data="operList2" highlight-current-row
											style="width: 98%;margin: 0 auto;" ref="table2" height="0">
											<el-table-column prop="SJSJ" label="时间" align="center" width='160'>
											</el-table-column>
											<el-table-column prop="SNWD" label="室内温度" align="center"></el-table-column>
											<el-table-column prop="SNSD" label="室内湿度" align="center"></el-table-column>
											<el-table-column prop="HSWD" label="进水温度" align="center"></el-table-column>
											<el-table-column prop="CSWD" label="出水温度" align="center"></el-table-column>
											<el-table-column prop="KGJZT" label="开关机" align="center"></el-table-column>
											<el-table-column prop="YJ1ZT" label="压机1状态" align="center">
											</el-table-column>
											<el-table-column prop="YJ2ZT" label="压机2状态" align="center">
											</el-table-column>
										</el-table>
										<!-- <dv-scroll-board :config="config2" style="width: 96%; height: 3.75rem;margin: 0 auto;" /> -->
									</div>
								</div>
								<div class="right mt-3" style="width: 48%;height: 4.5rem;">
									<operationRightChart ref="operationRightChart" :chartData="chartData" />
								</div>
							</div>
						</dv-border-box-6>
					</div>
				</div>
			</div>
		</dv-full-screen-container>
	</div>
</template>

<script>
	import Navbar from "../layout/Navbar";
	import operationRightChart from "@/components/echart/operationRightChart";
	import Cookies from 'js-cookie';
	export default {
		data() {
			return {
				loading: true,
				chart: null,
				config: {
					header: ["安装位置", "时间", "室内温度", "室内湿度", "进水温度", "出水温度", "开关机", "压机1状态",
						"压机2状态", "水泵状态", "电加热状态", "运行电流1", "运行电流2", "告警状态", "四通阀状态"
					],
					data: [],
					rowNum: 6, //表格行数
					headerHeight: 30,
					headerBGC: "#085E7D", //表头
					oddRowBGC: "#0f1325", //奇数行
					evenRowBGC: "#171c33", //偶数行
					index: false,
					columnWidth: [100, 160],
					align: ["center", "center", "center", "center", "center", "center", "center", "center",
						"center", "center", "center", "center", "center", "center", "center"
					],
				},
				config2: {
					header: ["时间", "室内温度", "室内湿度", "进水温度", "出水温度", "开关机", "压机1状态", "压机2状态"],
					data: [],
					rowNum: 6, //表格行数
					headerHeight: 30,
					headerBGC: "#085E7D", //表头
					oddRowBGC: "#0f1325", //奇数行
					evenRowBGC: "#171c33", //偶数行
					index: false,
					columnWidth: [160],
					align: ["center", "center", "center", "center", "center", "center", "center", "center"],
				},
				options: [],
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				value: '',
				value2: this.getNowTime(),
				value3: '',
				chartData: [],
				buildingSelect: [],
				buildingName: '',
				navbarType: true,
				building: '',
				operList1: [],
				operList2: [],
			};
		},
		components: {
			Navbar,
			operationRightChart,
		},
		watch: {
			'building': {
				handler() {
					this.locationToCode();
					this.runningData();
				},
			}
		},
		created() {
			this.getBuilding();
			this.cancelLoading();
		},
		mounted() {

		},
		methods: {
			async getBuilding() {
				await this.$axios.get("/api/buildings").then(res => {
					let buildingSelect = []
					for (let item of res.data.data) {
						buildingSelect.push({
							label: item.abbreviation,
							value: String(item.id)
						})
					}
					this.buildingSelect = buildingSelect
					if (Cookies.get('building')) {
						this.building = Cookies.get('building')
						this.buildingName = Cookies.get('buildingName')
					} else {
						Cookies.set('building', buildingSelect[0].value)
						Cookies.set('buildingName', buildingSelect[0].label)
						this.building = buildingSelect[0].value
						this.buildingName = buildingSelect[0].label
					}
					this.locationToCode();
					this.runningData();
				})
			},
			getNowTime() {
				var date = new Date();
				var seperator1 = "-";
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				var strDate = date.getDate() - 1;
				var endDate = date.getDate();
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				if (endDate >= 0 && endDate <= 9) {
					endDate = "0" + endDate;
				}
				var currentdate = year + seperator1 + month + seperator1 + strDate;
				var enddate = year + seperator1 + month + seperator1 + endDate;
				return [enddate + ' 00:00:00', enddate + " 23:59:59"];
			},
			timeChange() {
				this.historyData();
			},
			async locationToCode() {
				let dataObj = {
					building_id: this.building
				}
				await this.$axios.get("/api/airConditions/locationToCode", {
					params: dataObj
				}).then(res => {
					let options = [];
					for (let key in res.data.data) {
						options.push({
							value: res.data.data[key],
							label: key
						})
					}
					this.options = options
					this.value = options[0].value
					this.historyData()
				})
			},
			async historyData() {
				// console.log(this.value2)
				let dataObj = {
					control_panel_code: this.value,
					start_time: this.value2[0].substr(0, 10),
					end_time: this.value2[1].substr(0, 10),
				}
				this.config2 = {
					header: ["时间", "室内温度", "室内湿度", "进水温度", "出水温度", "开关机", "压机1状态", "压机2状态"],
					data: [],
					rowNum: 6, //表格行数
					headerHeight: 30,
					headerBGC: "#085E7D", //表头
					oddRowBGC: "#0f1325", //奇数行
					evenRowBGC: "#171c33", //偶数行
					index: false,
					columnWidth: [160],
					align: ["center", "center", "center", "center", "center", "center", "center",
						"center"
					],
				}
				await this.$axios.get("/api/buildings/historyData", {
					params: dataObj
				}).then(res => {
					let historyList = [];
					let wdData = [];
					let sdData = [];
					let timeData = [];
					for (let item of res.data.data) {
						historyList.push([
							String(item.SJSJ), String(item.SNWD), String(item.SNSD), String(item.HSWD),
							String(item.CSWD), String(item.KGJZT), String(item.YJ1ZT), String(item
								.YJ2ZT)
						])
						wdData.push(item.SNWD)
						sdData.push(item.SNSD)
						timeData.push(item.SJSJ)
					}
					this.operList2 = res.data.data
					this.chartData = [wdData, sdData, timeData];
					this.config2 = {
						header: ["时间", "室内温度", "室内湿度", "进水温度", "出水温度", "开关机", "压机1状态", "压机2状态"],
						data: historyList,
						rowNum: 6, //表格行数
						headerHeight: 30,
						headerBGC: "#085E7D", //表头
						oddRowBGC: "#0f1325", //奇数行
						evenRowBGC: "#171c33", //偶数行
						index: false,
						columnWidth: [160],
						align: ["center", "center", "center", "center", "center", "center", "center", "center"],
					}
				})
			},
			async runningData() {
				let dataObj = {
					building_id: this.building
				}
				this.config = {
					header: ["安装位置", "时间", "室内温度", "室内湿度", "进水温度", "出水温度", "开关机", "压机1状态",
						"压机2状态", "水泵状态", "电加热状态", "运行电流1", "运行电流2", "告警状态", "四通阀状态"
					],
					data: [],
					rowNum: 6, //表格行数
					headerHeight: 30,
					headerBGC: "#085E7D", //表头
					oddRowBGC: "#0f1325", //奇数行
					evenRowBGC: "#171c33", //偶数行
					index: false,
					columnWidth: [100, 160],
					align: ["center", "center", "center", "center", "center", "center", "center",
						"center", "center", "center", "center", "center", "center", "center",
						"center"
					],
				}
				await this.$axios.get("/api/buildings/runningData", {
					params: dataObj
				}).then(res => {
					let reportList = []
					for (let item of res.data.data) {
						reportList.push([
							String(item.location), String(item.SJSJ), String(item.SNWD), String(item
								.SNSD), String(item.HSWD), String(item.CSWD),
							String(item.KGJZT), String(item.YJ1ZT), String(item.YJ2ZT), String(item
								.SBZT), String(item.DJRZT), String(item.YJDL),
							String(item.DRDL), String(item.BJXH), String(item.STFZT)
						])
					}
					this.operList1 = res.data.data
					this.config = {
						header: ["安装位置", "时间", "室内温度", "室内湿度", "进水温度", "出水温度", "开关机", "压机1状态",
							"压机2状态", "水泵状态", "电加热状态", "运行电流1", "运行电流2", "告警状态", "四通阀状态"
						],
						data: reportList,
						rowNum: 6, //表格行数
						headerHeight: 30,
						headerBGC: "#085E7D", //表头
						oddRowBGC: "#0f1325", //奇数行
						evenRowBGC: "#171c33", //偶数行
						index: false,
						columnWidth: [100, 160],
						align: ["center", "center", "center", "center", "center", "center", "center",
							"center", "center", "center", "center", "center", "center", "center",
							"center"
						],
					}
				})
			},
			cancelLoading() {
				setTimeout(() => {
					this.loading = false;
				}, 1000);
			},
			logout() {
				this.$axios.post("/api/logout").then(res => {
					if (process.env.NODE_ENV === "production") {
						Cookies.remove('token', {
							domain: "hzng-iot.com"
						});
					} else {
						Cookies.set('token', '', -1)
					}
					this.$router.replace("/login");
				})
			},
			recordProgress: function(val) { //val用于接收子组件传过来的值
				this.building = val[0]
				this.buildingName = val[1]
			},
		},
	};
</script>

<style lang="scss">
	@import "../assets/scss/index.scss";

	#operation {
		.dv-scroll-board .header {
			background: linear-gradient(rgba(0, 0, 0, 0), #1C3B68) !important;
		}

		.rows .row-item {
			background-color: rgba(255, 255, 255, 0) !important;
		}

		.table-box {
			height: 4.8rem
		}

		.table-box2 {
			height: 3.8rem
		}
	}

	.el-input__inner {
		background: none;
		border: 0;
		color: #fff;
	
		.el-range-input {
			background: none;
			border: dimgray solid 1px;
			border-radius: 3px;
			color: #fff;
		}
	
		.el-range-separator {
			color: #fff;
			margin-right: 8px;
		}
	}

	.el-table__body tr.current-row>td {
		background: linear-gradient(to bottom, #2C4257, rgba(0, 0, 0, 0), #2C4257) !important;
		border-top: 1px #5D90C2 solid;
		border-bottom: 1px #5D90C2 solid;
	}
</style>
